import { UserDetailsContext } from "App";
import React, { useContext, useEffect, useRef } from "react";
import { hidePaymentRestrict, showPaymentRestrict } from "./payment/PaymentRestrict";
import { hideActionRestrict, showActionRestrict } from "./userAction/ActionRestrict";
import { hidePageRestrict, showPageRestrict } from "./page/PageRestrict";
import { useLocation } from "react-router-dom";

let planActions = null;
let userActions = null;

/*
useRestrictionChecker component:-
    --- this component is used in App which is root component for restriction functionality
    --- to disable restriction remove it from App.js
*/
const RestrictionChecker = () => {
  const userDetails = useContext(UserDetailsContext);
  planActions = userDetails?.planActions || null;
  userActions = userDetails?.userActions || null;
  return null;
};

/*
useRestrictionChecker component:-
  --- used in every component to check whether the action is in permitted list or not
  --- if userDetails is null or action list is not there restriction is disbaled
*/
export const useRestrictionChecker = () => {
  /*
    checkRestriction method:-
      --- this method checks for restriction, if restricted appropriate message is shown and returns true
      --- action : key from database which denotes the action eg: "SCHEDULE_A_SCAN"
      --- noAction : showing of message is disabled and only return true or false
      --- userRestrictMode : "action" - displays action restricted message else Page Restriction message
  */
  const checkRestriction = (action = null, noAction = false, userRestrictMode = "action", blockPageStyle=null) => {

    const restrictionsFor=["user","plan"];
    //const restrictionsFor=["user"];
    const doPlanRestrictions=restrictionsFor.includes("plan");
    const doUserRestrictions=restrictionsFor.includes("user");

    //if permitted action list based on plan and user management is not there, then restriction is disbaled
    if (planActions === null || userActions === null) 
      return false;

    //if action is not entered, checking is disabled for that action
    if (action === null) 
      return false;

    if (doPlanRestrictions && !planActions.includes(action)) 
    {
      if (!noAction) 
      {
        //delay is for rendering this componet after the rendering of the parent component to avoid many rendering
        setTimeout(() => showPaymentRestrict(true, action), 100);
        localStorage.setItem("forcedDropdownMode","-1");
      }
      return true;
    }

    if (doUserRestrictions && !userActions.includes(action)) 
    {
      if (!noAction) 
      {
        if (userRestrictMode === "action") 
          showActionRestrict(action);
        else
        {
          setTimeout(() => showPageRestrict(blockPageStyle, action), 100);
          localStorage.setItem("forcedDropdownMode","-1");
        }
      }
      return true;
    }

    return false;
  };

  return { checkRestriction };
};

export default RestrictionChecker;



export function useNotificationAutoCleanup() {
  const location = useLocation();

  useEffect(() => {
    hidePageRestrict();
    hideActionRestrict();
    hidePaymentRestrict();
  }, [location.pathname]);
}